import Endpoint from '@yw/hub.utilities.endpoint'
import store from '@/store'
import Message from '@/components/message'
import { v4 as uuidv4 } from 'uuid'
import { getToken, removeToken } from '@/utils/cache'

const lang = store && store.getters['app/language']

const { agile, interceptors } = new Endpoint({
  baseURL: `${process.env.VUE_APP_API}/v1`,
  timeout: 30000,
  requireAuth: true,
  headers: {
    contentType: 'application/json;charset=UTF-8',
    'Accept-Language': lang || 'zh'
  },
  withCredentials: true,
  setAuthorizationHeader: () => {
    const token = getToken()
    return token ? `Bearer ${token}` : ''
  }
})

// 添加刷新认证拦截器
interceptors.addRefreshTokenInterceptor({
  refreshTokenUrl: `${process.env.VUE_APP_APISERVER}/login/web/auth/refresh_token`,
  refreshTokenKey: `${process.env.VUE_APP_LOGIN_ENV}_token`,
  errorCallback: () => {
    is401()
  }
})

// interceptors.addRetryInterceptor()
// interceptors.addDuplicateInterceptor()
interceptors.addErrorInterceptor()

// 自定义拦截器
interceptors.registerRequestInterceptor(
  config => {
    // 神策埋点需加上以下字段
    config.headers.platform_type = 'pc'
    config.headers.platform_lang = lang
    config.headers.device_id = uuidv4()
    config.headers.anonymous_id = store.state.anonymousID
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

interceptors.registerResponseInterceptor(
  response => {
    if (response.data.code === 40001) {
      is401()
    } else if (!response.data.success) {
      // FIXME: 处理错误
      Message({ showClose: false, message: response.data.message, type: 'warning' })
      return Promise.reject(response.data)
    }
    return response
  },
  error => {
    if (error.code === 40001) {
      is401()
    } else if (error.code === 'ERR_CANCELED') {
      process.env.VUE_APP_LOGIN_ENV === 'dev' && Message.error(`接口重复请求：\n${error.config.url}`)
      console.error(`接口重复请求：${error.config.url}`)
    } else {
      Message({ showClose: false, message: error.message, type: 'warning' })
    }
    return Promise.reject(error)
  }
)

class Model {
  get(options = {}) {
    options.method = 'GET'
    return agile.request(options)
  }

  post(options = {}) {
    options.method = 'POST'
    return agile.request(options)
  }

  put(options = {}) {
    options.method = 'PUT'
    return agile.request(options)
  }

  delete(options = {}) {
    options.method = 'DELETE'
    return agile.request(options)
  }
}

function is401() {
  removeToken()
  if (window.location.pathname === '/login') {
    window.location.reload()
  } else {
    window.location.href = window.location.origin + '/login?return_url=' + encodeURIComponent(window.location.href)
  }
}

export default Model
export { agile, interceptors }
